import React, { useState } from 'react'
import PropTypes from 'prop-types'
import SecondaryButton from '../../../SecondaryButton'

const Label = props => {
  const { fieldId, labelText, helpText, toolTip, tipText } = props

  const [isOpen, setIsOpen] = useState(false)

  function handleToolTipToggle() {
    setIsOpen(!isOpen)
  }

  return (
    <div className="flex justify-between mb-2">
      <label
        htmlFor={fieldId}
        className="font-semibold text-md text-body-light"
      >
        {labelText}{' '}
        {helpText ? <span className="font-normal">{helpText}</span> : null}
      </label>
      {toolTip && toolTip === true && (
        <div
          className="flex items-center justify-center w-5 h-5 p-0 m-0 text-sm font-semibold leading-none border-2 rounded-full cursor-pointer text-secondary"
          onClick={handleToolTipToggle}
          onKeyPress={handleToolTipToggle}
          role="button"
          tabIndex={0}
        >
          ?
        </div>
      )}

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-20 flex items-center justify-center w-full h-screen p-8 cursor-pointer bg-black-25"
            id="modalBackground"
            role="none"
            onClick={handleToolTipToggle}
          >
            <div className="block w-full max-w-xl p-6 bg-white rounded-lg shadow-2xl">
              <div
                className="mb-4 text-sm leading-tight lg:text-base"
                dangerouslySetInnerHTML={{ __html: tipText }}
              />
              <SecondaryButton onClick={handleToolTipToggle}>
                Close
              </SecondaryButton>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

Label.propTypes = {
  fieldId: PropTypes.string,
  labelText: PropTypes.string,
  helpText: PropTypes.string,
  toolTip: PropTypes.bool,
  tipText: PropTypes.string,
}

export default Label
